export const normalizeEmptyEditorValue = (val: string): string => {
  return val === '<p><br></p>' ? '' : val;
};

export default normalizeEmptyEditorValue;
